import { Component, ReactNode } from 'react';
import * as Sentry from '@sentry/react';
import { ErrorService } from '../../services/errorService';
import { ErrorMessage } from '../error/ErrorMessage';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

export class GlobalErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    ErrorService.handle(error, {
      severity: 'high',
      context: { errorInfo }
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
          <div className="max-w-md w-full">
            <ErrorMessage
              message="Something went wrong"
              action={() => window.location.reload()}
              actionLabel="Refresh Page"
              variant="card"
            />
          </div>
        </div>
      );
    }

    return this.props.children;
  }
} 